var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from "@material-ui/core";
import React from "react";
import { useMemo } from "react";
import { SortIcon } from "../../../../..";
import FTLTableRow from "../FTLTableRow";
import FTLTableCell from "../FTLTableCell";
import clsx from "clsx";
import FTLTableStyles from "../../styles/FTLTableStyles.styles";
const HeaderComponents = ({ actionComponentWidth, showHeader, headerGroups, tableState, setTableState, classes: classesFromProps, }) => {
    const classes = FTLTableStyles();
    return (React.createElement(React.Fragment, null, useMemo(() => showHeader &&
        headerGroups.map((headerGroup) => {
            return (React.createElement(FTLTableRow, Object.assign({ type: "head" }, headerGroup.getHeaderGroupProps(), { key: headerGroup.id, className: classesFromProps === null || classesFromProps === void 0 ? void 0 : classesFromProps.headRow }),
                headerGroup.headers.map((column, index) => {
                    var _a;
                    const _b = column.getHeaderProps(column.getSortByToggleProps({ title: "" })), { onClick } = _b, otherHeadProps = __rest(_b, ["onClick"]);
                    const widthProps = typeof column.width === "number"
                        ? {
                            minWidth: column.width || column.minWidth || column.maxWidth,
                        }
                        : {
                            width: column.width,
                            minWidth: column.minWidth,
                            maxWidth: column.maxWidth,
                        };
                    return (React.createElement(FTLTableCell, Object.assign({ type: "head", key: column.id, textAlign: (_a = column === null || column === void 0 ? void 0 : column.align) !== null && _a !== void 0 ? _a : "left", isFocusable: column.canSort && tableState, tabIndex: column.canSort && tableState ? index : -1 }, widthProps, otherHeadProps, { className: clsx(column.showOnHover && classes.showOnHover, classesFromProps === null || classesFromProps === void 0 ? void 0 : classesFromProps.headCell), onClick: () => {
                            if (column.canSort && setTableState && tableState)
                                if (tableState.sortName === column.id &&
                                    tableState.sortDirection === "DESC")
                                    setTableState({
                                        sortDirection: "ASC",
                                        sortName: column.id,
                                    });
                                else if (tableState.sortName === column.id &&
                                    tableState.sortDirection === "ASC")
                                    setTableState({
                                        sortDirection: undefined,
                                        sortName: undefined,
                                    });
                                else
                                    setTableState({
                                        sortDirection: "DESC",
                                        sortName: column.id,
                                    });
                        } }),
                        React.createElement(Box, { display: column.canSort ? "inline-flex" : "block", overflow: "hidden", flexDirection: column.canSort && (column === null || column === void 0 ? void 0 : column.reverse)
                                ? "row-reverse"
                                : "row" },
                            column.render("Header"),
                            column.canSort && tableState ? (React.createElement(SortIcon, { sort: tableState.sortName === column.id
                                    ? tableState.sortDirection
                                    : undefined })) : null)));
                }),
                React.createElement("div", { style: {
                        minWidth: actionComponentWidth,
                        maxWidth: actionComponentWidth,
                        width: actionComponentWidth,
                        display: "flex",
                        alignItems: "flex-start",
                        position: "sticky",
                        opacity: 0,
                        right: 0,
                    } })));
        }), [headerGroups, showHeader, tableState, actionComponentWidth])));
};
export default HeaderComponents;
//# sourceMappingURL=HeaderComponents.js.map